import { ValidatorService } from '../tools/validator.service';
import { AutenticacionService } from '../autenticacion.service';
import { Http } from '@angular/http';
import { ConstantsService } from '../constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from '../tools/errors.service';

@Injectable()
export class CentroConsumoService {

  private service_url : string = '';
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService, 
      private validatorService: ValidatorService, 
      private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/centrosConsumo';
  }

  public update( credito : object) {
    return this.http.put(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public validate(centro : any){
    let error = [];

    if(!this.validatorService.required(centro.nombre_establecimiento)){
        error["nombre_establecimiento"] = this.errorService.required;
    }

    if(!this.validatorService.required(centro.direccion)){
        error["direccion"] = this.errorService.required;
    }

    if(!this.validatorService.required(centro.telefono)){
        error["telefono"] = this.errorService.required;
    }

    if(!this.validatorService.required(centro.giro)){
        error["giro"] = this.errorService.required;
    }

    return error;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/creditos/centro-consumo.service.ts